<template>
  <div>
    <div class="setting-card">

      <div class="setting-card_header">
        <span class="setting-card_header_name">{{title}}</span>
      </div>

      <div class="setting-card_content">
        <div v-for="(item, key) in list" :key="key" class="setting-card_content_channels content-item" >
          <div class="left">
            <span class="title">{{get_title(item)}}</span>
          </div>
          <div class="right">
            <span class="title">{{get_value(item)}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "status",
  props: ['title','list'],
  methods: {
    edit(setting){
      this.$emit('edit', setting)
    },
    get_title(item){
      let r = ''
      for (let key of Object.keys(item)) {
        r = key
      }
      return r
    },
    get_value(item){
      let r = ''
      for (let value of Object.values(item)) {
        r = value
      }
      return r
    },
  },
  computed: {
    params(key){
      let params = this.list[key]
      return params
    },
  }
}
</script>

<style lang="scss" scoped>

  .setting-card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    &_header {
      font: 300 14px/20px "Roboto", Arial, sans-serif;
      text-transform: uppercase;
      color: #000;
      background: #f4f3ef;
      padding: 6px 10px;
      border-radius: 10px 10px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &_content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        .left{
          width: 70%;
        }
        .right{
          width: 30%;
          justify-content: flex-end;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 12px;
          min-width: 0;
          span{
            white-space: normal;
            overflow-wrap: anywhere;
            text-align: left;
          }
        }
      }
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }

  @media (max-width: 475px) {
    .setting-card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }


</style>
